import { DEMO_STEPS, type DemoStep } from "./flows";
import { demoTemplateFor } from "./templates";
import type { AssetClassId } from "./types";

/**
 * The steps this desk can actually deliver.
 *
 * Only the comparison step is conditional, and only on whether the desk has a
 * filtered panel to compare against.
 *
 * The watchlist step used to be dropped when no concierge recording existed
 * for the desk, which meant that on a checkout with no fixtures the run went
 * compare -> highlight -> popout and then straight to a price. Nobody is going
 * to buy off the back of clicking a popout icon. Every desk now carries its
 * own watchlist, so the step always runs and the ask always lands after
 * something was built.
 */
export function visibleSteps(assetClass: AssetClassId): DemoStep[] {
  const hasFilteredWire = !!demoTemplateFor(assetClass)?.filteredWireId;
  return DEMO_STEPS.filter(
    (step) => step.id !== "compare" || hasFilteredWire
  );
}
